module.exports = __webpack_public_path__ + "static/img/yzfw.ecaeaa6c.png";